export default __webpack_public_path__ + "static/media/drink_pinpoint.2560bc1e.svg";